import { render, staticRenderFns } from "./addressView.vue?vue&type=template&id=4d147d56&scoped=true"
import script from "./addressView.vue?vue&type=script&lang=js"
export * from "./addressView.vue?vue&type=script&lang=js"
import style0 from "./addressView.vue?vue&type=style&index=0&id=4d147d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d147d56",
  null
  
)

export default component.exports